/**
 * content-section.tsx — Phase 050 ABox properties panel's Content section.
 *
 * Wraps the D-050-04-classification Content keys for the block-type in an
 * `<InspectorSection title="Content">` and renders one `<PropertyRow>` per
 * key. Returns `null` when the block-type has no Content keys
 * (e.g. `generic` / `container`) so the section header isn't rendered for
 * an empty list (CONTEXT D-050-04 — flat sections; no sub-grouping).
 */
import { InspectorSection } from '@/components/inspector'
import { getContentKeys } from './classification'
import { PropertyRow } from './property-row'
import type { AboxEnvelope } from '@/features/design-system/ontology/abox-render-prep'

export interface SectionProps {
  baseline: { env: AboxEnvelope; blockName: string; blockType: string }
  blockDrafts: Record<string, unknown>
}

export function ContentSection({ baseline, blockDrafts }: SectionProps) {
  const contentKeys = getContentKeys(baseline.blockType)
  if (contentKeys.length === 0) return null
  return (
    <InspectorSection title="Content">
      {contentKeys.map((key) => (
        <PropertyRow
          key={key}
          blockId={baseline.env.id}
          propertyKey={key}
          baselineValue={baseline.env.properties[key]}
          draftValue={blockDrafts[key]}
        />
      ))}
    </InspectorSection>
  )
}
